import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase, objectKeysSnakeCaseToCamelCase } from 'core/utils';
import { IShipTimePayload } from 'inventory/types';

export const getShipTimeStatus = async (payload: IShipTimePayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/inventory/display/ship-time-status?${getQueryStringToSnakeCase(payload)}`,
    signal
  );

  return objectKeysSnakeCaseToCamelCase(data);
};
